"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePassword = void 0;
const defaultOptions = {
    minLength: 8,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSpecialChars: true,
    specialChars: '=@#$-^&*(){}+?'
};
const validatePassword = (password, options = {}) => {
    const finalOptions = Object.assign(Object.assign({}, defaultOptions), options);
    const errors = [];
    // Built-in validation rules
    const rules = [
        // Minimum length rule
        {
            validator: (pwd) => pwd.length >= (finalOptions.minLength || 8),
            message: 'Password must be at least 8 characters long'
        },
        // Uppercase letter rule
        {
            validator: (pwd) => !finalOptions.requireUppercase || /[A-Z]/.test(pwd),
            message: 'Password must contain at least one uppercase letter'
        },
        // Lowercase letter rule
        {
            validator: (pwd) => !finalOptions.requireLowercase || /[a-z]/.test(pwd),
            message: 'Password must contain at least one lowercase letter'
        },
        // Number rule
        {
            validator: (pwd) => !finalOptions.requireNumbers || /[0-9]/.test(pwd),
            message: 'Password must contain at least one digit (0-9)'
        },
        // Special characters rule
        {
            validator: (pwd) => {
                var _a;
                return !finalOptions.requireSpecialChars ||
                    new RegExp(`[${(_a = finalOptions.specialChars) === null || _a === void 0 ? void 0 : _a.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}]`).test(pwd);
            },
            message: 'Password must contain at least one special character (=@#$-^&*(){}+?)'
        }
    ];
    // Combine built-in rules with custom rules
    const allRules = [...rules, ...(finalOptions.customRules || [])];
    // Check all rules
    allRules.forEach(rule => {
        if (!rule.validator(password)) {
            errors.push(rule.message);
        }
    });
    return {
        isValid: errors.length === 0,
        errors
    };
};
exports.validatePassword = validatePassword;
